import MyAccountStore from "@tajawal/ct-web-account-sdk/lib/stores";
import FlightsStore from "@tajawal/web-flights-sdk/lib/stores";
import UIStore from "./ui.store";
import { $cookie } from "@tajawal/web-core-sdk-v2/lib/services/cookie.service";
import { $localStorage } from "@tajawal/web-core-sdk/lib/services/local-storage.service";
import { useStaticRendering } from "mobx-react";
import { isSSR } from "@/utils/compute.utils";
import { COOKIE_KEYS, LOCAL_STORAGE_KEYS } from "@/constants/cache.constants";
import FlightsStoreV2 from "@tajawal/web-flights-sdk/lib/types/flights-store.types";

useStaticRendering(isSSR());

let store: Store;

type InitialState = {
  myAccountStore: MyAccountStore;
  appStore: FlightsStore;
  uiStore: UIStore;
  isMobile?: boolean;
};

export class Store {
  myAccountStore: MyAccountStore;
  appStore: FlightsStoreV2;
  uiStore: UIStore;

  constructor(initialState: Partial<InitialState>) {
    this.myAccountStore = new MyAccountStore(initialState.myAccountStore);
    this.appStore = new FlightsStore({
      initialState: initialState.appStore,
      V2: true,
      isMobile: initialState.isMobile,
    }) as FlightsStoreV2;
    // @ts-ignore
    this.uiStore = new UIStore(initialState.uiStore);
    store = this;
  }
}

export function initStore(
  initialData: Partial<InitialState> = {},
  reInitialize = false,
): Store {
  // Always make a new store if server, otherwise state is shared between requests
  if (isSSR() || reInitialize) {
    return new Store(initialData);
  }

  if (!store) {
    store = new Store(initialData);
    if ($cookie.get(COOKIE_KEYS.AUTH_TOKEN)) {
      store.myAccountStore.loginPage.loginStore.setIsLoggedIn(true);
      $localStorage.set(LOCAL_STORAGE_KEYS.LOGIN_SUCCESS, true);
    }
  }

  return store;
}
